import { SparklesIcon } from 'components/icons'
import { FieldWrapper } from 'components/rich/rich-input'
import { Input, Tooltip } from 'components/ui'
import { useRichContext, useRichField } from 'context/rich-context'
import { useField, useFormikContext } from 'formik'
import { Tool_V1_Data } from 'lib/assets/types/tool_v1'
import { defaultToolName } from 'lib/integrations/fusion/fusion-tools-to-toolpath-tools'
import { FC, InputHTMLAttributes } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  labelClassName?: string
  wrapper: FieldWrapper
}

export const ToolDescription: FC<Props> = ({
  name,
  className,
  labelClassName,
  wrapper: Wrapper,
  ...props
}) => {
  const { fieldSpec } = useRichField(name)
  const [field, meta, helpers] = useField(name)
  const { values } = useFormikContext()
  const { data, readOnly } = useRichContext()
  const showError = Boolean(meta.error) && meta.touched

  // When no value is set, use defaultToolName to generate a name matching what gets generated in fusionToolsToToolpathTools
  const isEmpty = field.value === '' || field.value == null
  let placeholder = ''
  if (isEmpty) {
    const tool = values as Tool_V1_Data
    placeholder = defaultToolName(
      tool?.post_number,
      tool?.description,
      tool?.type,
    )
  }

  return (
    <Wrapper
      name={name}
      label={fieldSpec?.inlineTitle || fieldSpec?.title}
      error={meta.error}
      wide={true}>
      <Tooltip tip="Auto-Generated Name" placement="bottom">
        <div className="relative ">
          <Input
            id={name}
            name={name}
            setValue={(value) => {
              helpers.setTouched(true)
              helpers.setValue(value)
            }}
            value={field.value}
            placeholder={placeholder}
            hasError={showError}
            readOnly={readOnly}
            inputClassName="placeholder:text-gray-300"
            {...props}
          />
          {isEmpty && (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <SparklesIcon className="size-4 text-gray-300" />
            </div>
          )}
        </div>
      </Tooltip>
    </Wrapper>
  )
}
